<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="M8.44434 8.44434L15.5553 15.5553"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.1357 8.80375C13.8428 9.09664 13.8428 9.57151 14.1357 9.86441C14.4286 10.1573 14.9035 10.1573 15.1963 9.86441L14.1357 8.80375ZM20.0851 4.97564C20.378 4.68275 20.378 4.20788 20.0851 3.91498C19.7922 3.62209 19.3173 3.62209 19.0244 3.91498L20.0851 4.97564ZM14.666 9.33408L15.1963 9.86441L20.0851 4.97564L19.5548 4.44531L19.0244 3.91498L14.1357 8.80375L14.666 9.33408Z"
        fill="currentColor"
      />
      <path
        d="M3.91498 19.0244C3.62209 19.3173 3.62209 19.7922 3.91498 20.0851C4.20788 20.378 4.68275 20.378 4.97564 20.0851L3.91498 19.0244ZM9.86441 15.1963C10.1573 14.9035 10.1573 14.4286 9.86441 14.1357C9.57151 13.8428 9.09664 13.8428 8.80375 14.1357L9.86441 15.1963ZM4.44531 19.5548L4.97564 20.0851L9.86441 15.1963L9.33408 14.666L8.80375 14.1357L3.91498 19.0244L4.44531 19.5548Z"
        fill="currentColor"
      />
      <path
        d="M16 4.23663C16.7506 4.22596 19.2363 3.70959 19.7634 4.23663C20.2904 4.76367 19.774 7.24941 19.7634 8"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.23663 16C4.22596 16.7506 3.70959 19.2363 4.23663 19.7634C4.76367 20.2904 7.24941 19.774 8 19.7634"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
</template>
<script setup lang="ts"></script>
<style lang=""></style>
